<template>
  <LeaseDetail
    :is-mobile="$q.screen.xs"
    :loading="leaseLoading"
    :lease="lease"
    :savings="savings"
    @back="goBack"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'LeaseDetailWidget',
  props: {
    leaseId: undefined
  },
  computed: {
    ...mapState({
      lease: (state) => state.lease.lease,
      leaseLoading: (state) => state.lease.leaseLoading
    }),
    savings() {
      return [
        {
          label: 'Car Lease Cost',
          value: this.$options.filters.currency(this.lease.carLeaseCost)
        },
        {
          label: 'Running Budget Cost',
          value: this.$options.filters.currency(this.lease.runningBudgetCost)
        },
        {
          label: 'Other costs',
          value: this.$options.filters.currency(this.lease.otherCosts)
        }
      ];
    }
  },
  methods: {
    ...mapActions('lease', ['getLease']),
    goBack() {
      this.$router.push({
        name: this.$RouteNames.dashboard
      });
    }
  },
  async mounted() {
    await this.getLease(this.leaseId);
  },
  components: {
    LeaseDetail: () => import('../../components/page/lease-detail')
  }
};
</script>
